import { FundSeriesAndInvestor } from 'model/series';
import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { GetAllSecondaryAccessSeriesTypes } from './types';

export const getAllSecondaryAccessSeriesRequest = () => action(GetAllSecondaryAccessSeriesTypes.GET_ALL_SECONDARY_ACCESS_SERIES_REQUEST);
export const getAllSecondaryAccessSeriesSuccess = (response: FundSeriesAndInvestor[]) => action(GetAllSecondaryAccessSeriesTypes.GET_ALL_SECONDARY_ACCESS_SERIES_SUCCESS, response);
export const getAllSecondaryAccessSeriesError = (error: GiroWebappError) => action(GetAllSecondaryAccessSeriesTypes.GET_ALL_SECONDARY_ACCESS_SERIES_ERROR, error);
export const getAllSecondaryAccessSeriesResetState = () => action(GetAllSecondaryAccessSeriesTypes.GET_ALL_SECONDARY_ACCESS_SERIES_RESET_STATE);
